import * as Types from "Types";
import { css } from "styled-components";
import * as enums from "enumerations";

export const grid: Types.Grid.Values = {
   xxl: {
      count: 24,
      min: 1400,
      columnGap: "15px",
      rowGap: "15px",
      marginVertical: "0px",
      marginHorizontal: "0px",
   },
   xl: {
      count: 15,
      min: 1200,
      columnGap: "15px",
      rowGap: "15px",
      marginVertical: "0px",
      marginHorizontal: "0px",
   }, // >= 1200
   l: {
      count: 12,
      min: 992,
      columnGap: "15px",
      rowGap: "15px",
      marginVertical: "0px",
      marginHorizontal: "0px",
   }, // >= 992
   m: {
      count: 4,
      min: 768,
      columnGap: "15px",
      rowGap: "15px",
      marginVertical: "0px",
      marginHorizontal: "0px",
   }, // >= 768
   s: {
      count: 2,
      min: 576,
      columnGap: "15px",
      rowGap: "15px",
      marginVertical: "0px",
      marginHorizontal: "0px",
   }, // >= 576
   xs: {
      count: 2,
      min: 0,
      columnGap: "10px",
      rowGap: "10px",
      marginVertical: "0px",
      marginHorizontal: "0px",
   },
};

export function getGridSize(width: number): Types.Grid.Size {
   if (width >= grid.xxl.min) return enums.grid.sizes.xxl;
   if (width >= grid.xl.min && width < grid.xxl.min) return enums.grid.sizes.xl;
   if (width >= grid.l.min && width < grid.xl.min) return enums.grid.sizes.l;
   if (width >= grid.m.min && width < grid.l.min) return enums.grid.sizes.m;
   if (width >= grid.s.min && width < grid.m.min) return enums.grid.sizes.s;
   if (width < grid.s.min) return enums.grid.sizes.xs;

   return enums.grid.sizes.xxl;
}

export function gridCss(props: Types.Grid.Css) {
   const size = getGridSize(props.width);
   if (size === enums.grid.sizes.xxl && props.sizes.xxl) return props.sizes.xxl && props.sizes.xxl;
   if (size === enums.grid.sizes.xl && props.sizes.xl) return props.sizes.xl && props.sizes.xl;
   if (size === enums.grid.sizes.l && props.sizes.l) return props.sizes.l && props.sizes.l;
   if (size === enums.grid.sizes.m && props.sizes.m) return props.sizes.m && props.sizes.m;
   if (size === enums.grid.sizes.s && props.sizes.s) return props.sizes.s && props.sizes.s;
   if (size === enums.grid.sizes.xs && props.sizes.xs) return props.sizes.xs && props.sizes.xs;
}

export function gridColumns(props: Types.Grid.Columns) {
   const size = getGridSize(props.width);
   if (size === enums.grid.sizes.xxl)
      return css`
         grid-column: auto / span ${props.sizes.xxl ? props.sizes.xxl : grid.xxl.count};
      `;
   if (size === enums.grid.sizes.xl)
      return css`
         grid-column: auto / span ${props.sizes.xl ? props.sizes.xl : grid.xl.count};
      `;
   if (size === enums.grid.sizes.l)
      return css`
         grid-column: auto / span ${props.sizes.l ? props.sizes.l : grid.l.count};
      `;
   if (size === enums.grid.sizes.m)
      return css`
         grid-column: auto / span ${props.sizes.m ? props.sizes.m : grid.m.count};
      `;
   if (size === enums.grid.sizes.s)
      return css`
         grid-column: auto / span ${props.sizes.s ? props.sizes.s : grid.s.count};
      `;
   if (size === enums.grid.sizes.xs)
      return css`
         grid-column: auto / span ${props.sizes.xs ? props.sizes.xs : grid.xs.count};
      `;
}

export function shows(props: Types.Grid.Shows) {
   const size = getGridSize(props.width);
   if (props.sizes[size] === undefined) return true;
   if (size === enums.grid.sizes.xxl && props.sizes.xxl) return true;
   if (size === enums.grid.sizes.xl && props.sizes.xl) return true;
   if (size === enums.grid.sizes.l && props.sizes.l) return true;
   if (size === enums.grid.sizes.m && props.sizes.m) return true;
   if (size === enums.grid.sizes.s && props.sizes.s) return true;
   if (size === enums.grid.sizes.xs && props.sizes.xs) return true;

   return false;
}

export const Typography = {
   h1: css`
      font-size: 31px;
      font-weight: 700;
      color: #000;
   `,
   h2: css`
      font-size: 27px;
      color: #000;
   `,
   h3: css`
      font-size: 23px;
      color: #000;
   `,
   subtitle1: css`
      font-size: 15px;
      color: #8f8f8f;
   `,
   subtitle2: css`
      font-size: 15px;
      color: #000;
   `,
   description1: css`
      font-size: 15px;
      color: #000;
   `,
};
